import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type GroupInboxFormStore } from 'pages/settings/pages/inboxes/pages/inboxesView/store/groupInboxFormStore'

export type IGroupInboxModalActionProps = {
  store: GroupInboxFormStore
  isEdit?: boolean
}

export const GroupInboxModalAction = observer(({ store, isEdit }: IGroupInboxModalActionProps) => (
  <Button
    contained='primary'
    text={isEdit ? 'Save' : 'Create Group Inbox'}
    onClick={() => store.createGroupInbox(isEdit)}
    loading={store.groupInboxModalLoading}
    disabled={store.groupInboxModalLoading}
  />
))
